import axios from 'src/utils/axios';

// ACCOUNTS
export const createAccount = async (payload) => {
  const response = await axios.post('/api/AccountCatalog', payload);
  return response;
};

export const getAccounts = async () => {
  const response = await axios.get('api/AccountCatalog');
  return response;
};

// BANKS
export const createBank = async (payload) => {
  const response = await axios.post('/api/Bank/Bank', payload);
  return response;
};

export const getBanks = async () => {
  const response = await axios.get('api/Bank/Bank');
  return response;
};

// BANK ACCOUNTS
export const createBankAccount = async (payload) => {
  const response = await axios.post('/api/BankAccount/BankAccount', payload);
  return response;
};

export const getBankAccounts = async () => {
  const response = await axios.get('api/BankAccount/Bank');
  return response;
};

export const getBankAccountsById = async (id) => {
  const response = await axios.get(`api/BankAccount/Bank/${id}`);
  return response;
};

// CHECKS
export const createCheck = async (payload) => {
  const response = await axios.post('/api/Checks/checks', payload);
  return response;
};

export const getChecks = async () => {
  const response = await axios.get('api/Checks/checks');
  return response;
};

export const deleteCheck = async (id) => {
  const response = await axios.delete(`api/Checks/checks/${id}`);
  return response;
};

export const updateCheck = async (id, payload) => {
  const response = await axios.put(`api/Checks/checks/${id}`, payload);
  return response;
};

export const getChecksWithDetails = async () => {
  try {
    // Obtener cheques
    const checksResponse = await axios.get('api/Checks/checks');

    if (checksResponse.status === 200) {
      // Obtener cuentas bancarias para mapear nombres
      const bankAccountsResponse = await axios.get('api/BankAccount/Bank');
      const bankAccounts = bankAccountsResponse.status === 200 ? bankAccountsResponse.data : [];

      // Crear un mapa de cuentas bancarias por ID
      const bankAccountsMap = bankAccounts.reduce((acc, account) => {
        acc[account.bankAccountId] = account;
        return acc;
      }, {});

      // Transformar los datos de cheques

      const transformedChecks = checksResponse.data.map((check) => ({
        checkId: check.checkId,
        checkNumber: check.checkNumber,
        bankAccount: {
          name: `Cuenta ${check.bankAccountNumber}`,
          number: check.bankAccountNumber,
          type: bankAccountsMap[check.bankAccountId]?.type || 'Activo',
        },
        amount: check.amount,
        description: check.description,
        templateId: check.templateId,
        createDate: check.createDate,
        checkDate: check.checkDate,
        recievedName: check.recievedName,
        createUser: check.createUser,
        accountCatalog: check.accountCatalog,
        isDeleted: check.isDeleted,
        // Campos adicionales para compatibilidad con el componente
        receivedBy: check.recievedName,
        receivedDate: check.createDate, // Campo temporal
        creationDate: check.createDate,
        createdBy: check.createdUser.employee || 'Usuario del sistema',
      }));

      return {
        status: 200,
        data: transformedChecks,
      };
    }

    return checksResponse;
  } catch (error) {
    console.error('Error fetching checks with details:', error);
    throw error;
  }
};

export const getChecksById = async (id) => {
  const response = await axios.get(`api/Checks/checks/${id}`);
  return response;
};

// JOURNAL ENTRY
export const getAllJournalEntries = async () => {
  const response = await axios.get('/api/JournalEntry');
  return response;
};

export const getJournalEntriesbyTransaction = async () => {
  const response = await axios.get('/api/JournalEntry/byTransactions');
  return response;
};

// INVOICE ACCOUNTING
export const getInvoiceAccounting = async (startDate, endDate) => {
  const formattedStartDate = startDate instanceof Date ? startDate.toISOString() : startDate;
  const formattedEndDate = endDate instanceof Date ? endDate.toISOString() : endDate;

  const response = await axios.get(
    `/api/InvoiceAccounting?startDate=${formattedStartDate}&endDate=${formattedEndDate}`
  );
  return response;
};
export const getInvoiceAccountingAll = async () => {
  const response = await axios.get('api/InvoiceAccounting/all');
  return response;
};

export const getInvoiceAccountingById = async (id) => {
  const response = await axios.get(`/api/InvoiceAccounting/${id}`);
  return response;
};

export const createInvoiceAccounting = async (payload) => {
  const response = await axios.post('/api/InvoiceAccounting', payload);
  return response;
};

export const buildUpdateInvoiceAccountingPayload = (payload = {}, invoiceAccountingId) => {
  const id = payload.invoiceAccountingId || invoiceAccountingId;
  const details = Array.isArray(payload.details) ? payload.details : [];
  const subTotalPrice = Number(payload.subTotalPrice || 0);
  const totalTax = Number(payload.totalTax || 0);

  if (subTotalPrice <= 0) {
    throw new Error('Sub Total Price must be greater than 0');
  }

  if (totalTax < 0) {
    throw new Error('Total Tax cannot be negative');
  }

  return {
    invoiceAccountingId: id,
    providerId: payload.providerId,
    purchaseOrderId: payload.purchaseOrderId,
    invoiceAccountingType: payload.invoiceAccountingType,
    paymentDate: payload.paymentDate,
    nfc: payload.NFC || '',
    deadlineDate: payload.deadlineDate,
    subTotalPrice,
    totalTax,
    mediaId: payload.mediaId || null,
    details: details.map((detail) => ({
      invoiceAccountingDetailId: detail.invoiceAccountingDetailId || null,
      invoiceAccountingId: detail.invoiceAccountingId || id,
      concepto: detail.concepto || '',
      cantidad: Number(detail.cantidad || 0),
      precioUnitario: Number(detail.precioUnitario || 0),
    })),
  };
};

export const updateInvoiceAccounting = async (id, payload) => {
  const updatePayload = buildUpdateInvoiceAccountingPayload(payload, id);
  const response = await axios.put(`/api/InvoiceAccounting/${id}`, updatePayload);
  return response;
};

export const deleteInvoiceAccounting = async (id) => {
  const response = await axios.delete(`/api/InvoiceAccounting/${id}`);
  return response;
};

export const payInvoiceAccounting = async (id, payload) => {
  const response = await axios.post(`/api/InvoiceAccounting/${id}/pay`, payload);
  return response;
};

// JOURNAL ENTRIES
export const getGroupedJournalEntries = async (startDate, endDate) => {
  const response = await axios.get('/api/JournalEntry/grouped-by-document', {
    params: {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
    },
  });
  return response;
};

/**
 * Registra un asiento contable manual completo. El backend valida partida doble,
 * existencia de las cuentas y que todas admitan movimientos antes de persistir.
 *
 * @param {{
 *   entryTypeCode: string,
 *   entryTypeName?: string,
 *   reference?: string,
 *   concept: string,
 *   entryDate: string,
 *   lines: Array<{ accountId: string, description?: string, isDebit: boolean, amount: number }>
 * }} payload
 */
export const createManualJournalEntry = async (payload) => {
  const response = await axios.post('/api/JournalEntry/manual', payload);
  return response;
};

export const getForIncomeStatement = async (startDate, endDate) => {
  const response = await axios.get('/api/JournalEntry/forIncomeStatement', {
    params: {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
    },
  });
  return response;
};

// LOANS
export const getLoans = async () => {
  const response = await axios.get('/api/Loans/Loans');
  return response;
};

export const getLoanById = async (id) => {
  const response = await axios.get(`/api/Loans/Loans/${id}`);
  return response;
};

export const createLoan = async (payload) => {
  // Formato esperado por el API según el curl proporcionado
  const loanPayload = {
    bankAccountId: payload.bankAccountId,
    loanAmount: payload.loanAmount || 0,
    annualInterestRate: payload.annualInterestRate || 0,
    loanTermMonths: payload.loanTermMonths || 0,
    transacctionId: payload.transacctionId,
    createUser: payload.createUser || '00000000-0000-0000-0000-000000000000',
  };

  const response = await axios.post('/api/Loans/Loans', loanPayload);
  return response;
};

export const updateLoan = async (id, payload) => {
  // Formato esperado por el API para actualización según el curl proporcionado
  const updatePayload = {
    bankAccountId: payload.bankAccountId,
    loanAmount: payload.loanAmount || 0,
    annualInterestRate: payload.annualInterestRate || 0,
    loanTermMonths: payload.loanTermMonths || 0,
    transacctionId: payload.transacctionId,
    createUser: payload.createUser || payload.userId || '00000000-0000-0000-0000-000000000000',
  };

  const response = await axios.put(`/api/Loans/Loans/${id}`, updatePayload);
  return response;
};

export const deleteLoan = async (id) => {
  const response = await axios.delete(`/api/Loans/Loans/${id}`);
  return response;
};

export const getLoanAmortization = async (id) => {
  const response = await axios.get(`/api/Loans/Amortizacion/${id}`);
  return response;
};

export const getLoanPayAmortization = async (id) => {
  const response = await axios.get(`/api/Loans/PayAmortizacion/${id}`);
  return response;
};

export const deleteLoanCheck = async (id) => {
  const response = await axios.delete(`/api/Loans/checks/${id}`);
  return response;
};

export const getLoansWithDetails = async () => {
  try {
    const response = await axios.get('/api/Loans/Loans');

    if (response.status === 200) {
      // Transformar los datos para compatibilidad con el componente
      const transformedLoans = response.data.map((loan) => ({
        loanId: loan.loanId,
        loanAmount: loan.loanAmount,
        annualInterestRate: loan.annualInterestRate,
        loanTermMonths: loan.loanTermMonths,
        createDate: loan.createDate,
        startedDate: loan.startedDate,
        finalDate: loan.finalDate,
        status: loan.status,
        isDeleted: loan.isDeleted,
        // Información de la cuenta bancaria
        bankAccount: {
          bankAccountId: loan.accountNumber?.bankAccountId,
          account: loan.accountNumber?.account,
          accountType: loan.accountNumber?.accountType,
          balance: loan.accountNumber?.balance,
          bank: {
            bankId: loan.accountNumber?.bank?.bankId,
            bankName: loan.accountNumber?.bank?.bankName,
          },
        },
        // Información del usuario creador
        createdUser: {
          userId: loan.createdUserName?.userId,
          username: loan.createdUserName?.username,
          employee: loan.createdUserName?.employee,
        },
        // Campos adicionales para compatibilidad
        bankAccountId: loan.accountNumber?.bankAccountId,
        createUser: loan.createdUserName?.userId,
        transacctionId: loan.transacctionId,
      }));

      return {
        status: 200,
        data: transformedLoans,
      };
    }

    return response;
  } catch (error) {
    console.error('Error fetching loans with details:', error);
    throw error;
  }
};

export const getPayRoll = async () => {
  const response = await axios.get('/api/PayRoll');
  return response;
};

export const getPayRollInfo = async () => {
  const response = await axios.get('/api/PayRoll/Assigned');
  return response;
};

export const postPayRollAssigned = async (payload) => {
  const response = await axios.post('/api/PayRoll/Assigned', payload);
  return response;
};

export const deletePayRollAssigned = async (payload) => {
  const response = await axios.delete('/api/PayRoll/Assigned', {
    data: payload,
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response;
};

export const getDeductions = async () => {
  const response = await axios.get('/api/Deductions');
  return response;
};

export const createPayRoll = async (payload) => {
  const response = await axios.post('/api/PayRoll', payload);
  return response;
};

export const deletePayRoll = async (id) => {
  const response = await axios.delete(`/api/PayRoll/${id}`);
  return response;
};

export const updatePayRoll = async (id, payload) => {
  const response = await axios.put(`/api/PayRoll/${id}`, payload);
  return response;
};

export const getPayRollInfoById = async (id) => {
  const response = await axios.get(`/api/PayRoll/Info/${id}`);
  return response;
};

export const employeeDeductionsPost = async (payload) => {
  const response = await axios.post('/api/Deductions/Asign', payload);
  return response;
};

export const employeeDeductionsDelete = async (payload) => {
  const response = await axios.delete('/api/Deductions/Asign', {
    data: payload,
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response;
};

export const doctorDeductionsPost = async (payload) => {
  const response = await axios.post('/api/Deductions/AsignDoctorDeduction', payload);
  return response;
};

export const doctorDeductionsDelete = async (payload) => {
  const response = await axios.delete('/api/Deductions/AsignDoctorDeduction', {
    data: payload,
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response;
};

export const getAllMapping = async (type) => {
  const response = await axios.get('/api/PayRoll/allMapping', {
    params: { type },
  });
  return response;
};

// DOCTOR PAYROLL BY DATE RANGE
export const getDoctorPayrollByDate = async (payload) => {
  const response = await axios.post('/api/PayRoll/Doctor', payload);
  return response;
};

export const getDoctorEmergencyPayrollByDate = async (payload) => {
  // payload: { doctorIds: string[], startDate: 'YYYY-MM-DD', endDate: 'YYYY-MM-DD' }
  const response = await axios.post('/api/PayRoll/Doctor-Emergency', payload);
  return response;
};

// DOCTOR ICU (UCI) PAYROLL BY DATE RANGE
export const getDoctorICUPayrollByDate = async (payload) => {
  // payload: { doctorIds: string[], startDate: 'YYYY-MM-DD', endDate: 'YYYY-MM-DD' }
  const response = await axios.post('/api/PayRoll/Doctor-UCI', payload);
  return response;
};

export const getDoctorCouncilPayrollByDate = async (payload) => {
  // payload: { doctorIds: string[], startDate: 'YYYY-MM-DD', endDate: 'YYYY-MM-DD' }
  const response = await axios.post('/api/PayRoll/Doctor-Council', payload);
  return response;
};

// DOCTOR ESPECIALIDAD PAYROLL BY DATE RANGE
export const getDoctorEspecialidadPayrollByDate = async (payload) => {
  // payload: { doctorIds: string[], startDate: 'YYYY-MM-DD', endDate: 'YYYY-MM-DD' }
  const response = await axios.post('/api/PayRoll/Doctor-Especialidad', payload);
  return response;
};

export const saveDoctorEmergencyPayroll = async (payload) => {
  const response = await axios.post('/api/PayRoll/save-Doctor-Planta', payload);
  return response;
};

export const getDoctorPlanta = async (period) => {
  const response = await axios.post('/api/PayRoll/Doctor-Planta', period);
  return response;
};
export const getDoctorServices = async (period) => {
  const response = await axios.post('/api/PayRoll/Doctor-Services-laboratory-image', period);
  return response;
};
// GET DOCTOR PLANTA PAYROLL DETAIL BY PAYROLL ID
export const getDoctorPlantaPayrollDetail = async (payrollId) => {
  const response = await axios.get(`/api/PayRoll/Doctor-Planta/${payrollId}`);
  return response;
};

export const getDoctorDeductionsPreview = async (payload) => {
  const response = await axios.post(
    '/api/PayRoll/Doctor-Assigned-otherPayrollsTypes-getPreview',
    payload
  );
  return response.data;
};

// UPDATE DOCTOR PLANTA PAYROLL
// Params: payrollId (string), doctorList (array)
export const updateDoctorPlantaPayroll = async (payrollId, doctorList) => {
  const response = await axios.put(
    `/api/PayRoll/Doctor-Planta-BatchByPayroll/${payrollId}`,
    doctorList
  );
  return response;
};

// ==================== DOCTOR OTHER SERVICES (Emergencia, Especialidad, UCI, Gastro) ====================
// Este servicio maneja todos los tipos de doctores EXCEPTO Planta
// Tipos soportados: Emergencia (2), Especialidad (3), Gastro (4), UCI (7)

// SAVE DOCTOR OTHER SERVICES PAYROLL (CREATE)
export const saveDoctorOtherServicesPayroll = async (payload) => {
  const response = await axios.post('/api/PayRoll/Doctor-Other-Services', payload);
  return response;
};

// GET DOCTOR OTHER SERVICES PAYROLL DETAIL BY PAYROLL ID
// Este servicio obtiene los detalles para Emergencia, Especialidad, Gastro y UCI
export const getDoctorOtherServicesPayrollDetail = async (payrollId) => {
  const response = await axios.get(`/api/PayRoll/Doctor-Other-Services/${payrollId}`);
  return response;
};

// GET DOCTOR EMERGENCIA PAYROLL DETAIL BY PAYROLL ID
export const getDoctorEmergenciaPayrollDetail = async (payrollId) => {
  const response = await axios.get(`/api/PayRoll/Doctor-Emergencia/${payrollId}`);
  return response;
};

// UPDATE DOCTOR EMERGENCIA PAYROLL
export const updateDoctorEmergenciaPayroll = async (payrollId, doctorList) => {
  const response = await axios.put(
    `/api/PayRoll/Doctor-Emergencia-BatchByPayroll/${payrollId}`,
    doctorList
  );
  return response;
};

// GET DOCTOR ESPECIALIDAD PAYROLL DETAIL BY PAYROLL ID
export const getDoctorEspecialidadPayrollDetail = async (payrollId) => {
  const response = await axios.get(`/api/PayRoll/Doctor-Especialidad/${payrollId}`);
  return response;
};

// UPDATE DOCTOR ESPECIALIDAD PAYROLL
export const updateDoctorEspecialidadPayroll = async (payrollId, doctorList) => {
  const response = await axios.put(
    `/api/PayRoll/Doctor-Especialidad-BatchByPayroll/${payrollId}`,
    doctorList
  );
  return response;
};

// GET DOCTOR UCI PAYROLL DETAIL BY PAYROLL ID
export const getDoctorUCIPayrollDetail = async (payrollId) => {
  const response = await axios.get(`/api/PayRoll/Doctor-UCI/${payrollId}`);
  return response;
};

// UPDATE DOCTOR UCI PAYROLL
export const updateDoctorUCIPayroll = async (payrollId, doctorList) => {
  const response = await axios.put(
    `/api/PayRoll/Doctor-UCI-BatchByPayroll/${payrollId}`,
    doctorList
  );
  return response;
};

// GET DOCTOR GASTRO PAYROLL DETAIL BY PAYROLL ID
export const getDoctorGastroPayrollDetail = async (payrollId) => {
  const response = await axios.get(`/api/PayRoll/Doctor-Gastro/${payrollId}`);
  return response;
};

// UPDATE DOCTOR GASTRO PAYROLL
export const updateDoctorGastroPayroll = async (payrollId, doctorList) => {
  const response = await axios.put(
    `/api/PayRoll/Doctor-Gastro-BatchByPayroll/${payrollId}`,
    doctorList
  );
  return response;
};

export const createDeduction = async (payload) => {
  const response = await axios.post('/api/Deductions', payload);
  return response;
};

export const deleteDeduction = async (id) => {
  const response = await axios.delete(`/api/Deductions/${id}`);
  return response;
};

export const getDeductionsEvenDeleted = async () => {
  const response = await axios.get(`/api/Deductions/evenEliminated`);
  return response;
};

export const AmountDataDoctorMappingAmounts = async (doctorId, payrollDoctorId) => {
  try {
    const response = await axios.get(`/api/PayRoll/getAmountBy${doctorId}And${payrollDoctorId}`);
    return response;
  } catch (error) {
    console.error(error);
    throw new Error();
  }
};


// PETTY CASH
export const getPettyCash = async () => {
  const response = await axios.get('/api/PettyCashInfo');
  return response;
};

export const createPettyCashRequest = async (payload) => {
  const response = await axios.post('/api/PettyCashInfo', payload);
  return response;
};

export const updatePettyCashRequest = async (id, payload) => {
  const response = await axios.put(`/api/PettyCashInfo/${id}`, payload);
  return response;
};

export const getPettyCashTransactions = async (pettyCashId) => {
  const endpoint = pettyCashId 
    ? `/api/PettyCashTransactionsInfo?pettyCashId=${pettyCashId}`
    : '/api/PettyCashTransactionsInfo';
  const response = await axios.get(endpoint);
  return response;
};

export const createPettyCashTransaction = async (payload) => {
  const response = await axios.post('/api/PettyCashTransactionsInfo', payload);
  return response;
};

export const deletePettyCashTransaction = async (id) => {
  const response = await axios.delete(`/api/PettyCashTransactionsInfo/${id}`);
  return response;
};

export const deletePettyCashRequest = async (id) => {
  const response = await axios.delete(`/api/PettyCashInfo/${id}`);
  return response;
};

export const deletePettyCash = async (id) => {
  const response = await axios.delete(`/api/PettyCashInfo/${id}`);
  return response;
};
